@let ctaLink = this.ctaLink();
@let ctaAnchor = this.ctaAnchor();
<a
    [hNoFollowOnFilteredGrid]="ctaLink ? ctaLink.path : undefined"
    [attr.aria-label]="ariaLabel()"
    (click)="ctaLink ? mediaRedirection($event, ctaLink) : scrollToElement($event, ctaAnchor)"
    [href]="ctaLink ? ctaLink.path : urlWithAnchor()"
    [attr.tabindex]="tabIndexOverride() ?? null"
    class="media-link"
    [class.keyboard-navigation]="isKeyboardNavigation$ | async"
    [style.--focus-offset]="focusOffset() !== undefined ? focusOffset() + 'px' : null">
    <ng-content />
</a>
